enum EditorType {
    SIMPLE_CHECKLIST = 'simpleChecklist', //used by checklist (not custom)
    HEADER = 'header',
    CHECKBOX = 'checkbox',
    TEXTFIELD = 'textfield',
    TEXTAREA = 'textarea',
    MASK = 'mask',
    COUNTRY = 'country',
    USER = 'user',
    DROPDOWN = 'dropdown',
    INTEGER = 'integer',
    DECIMAL = 'decimal',
    DATE = 'date',
    CATEGORY = 'category',
    DEPARTMENT = 'department',
    INSPECTING_COMPANY = 'inspectingCompany',
    INSPECTOR = 'inspector',
    LOOKUP = 'lookup',
}

export default EditorType;